var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaofangguandao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.72729C11.4724 2.72729 7.84539 2.72729 5.38431 2.72729C3.92829 2.72729 2.75 3.90763 2.75 5.36366V5.36366C2.75 6.81968 3.93034 8.00002 5.38636 8.00002H11.0909C12.5595 8.00002 13.75 9.19054 13.75 10.6591V10.6591C13.75 12.1277 12.5595 13.3182 11.0909 13.3182H2.75",
    stroke: "#FF0000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.04545,
    y: 10.6591,
    width: 0.590909,
    height: 5.31818,
    stroke: "#0C0C0C",
    strokeWidth: 0.590909
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: -0.0227051,
    width: 0.5,
    height: 5.5,
    stroke: "#0C0C0C",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaofangguandao);
export default __webpack_public_path__ + "static/media/xiaofangguandao.cd50553477cdc802502443ae8a39026b.svg";
export { ForwardRef as ReactComponent };